import SimpleBar from 'simplebar';

export default class MobileScroll {
  constructor(options) {
    this.scrolls = [];
    this.options = {...MobileScroll.options, ...options};
  }

  static options = {
    selector: '.js-mobile-scroll',
    breakpoint: window.breakpoints.tablet,
    simplebarSettings: {
      forceVisible: 'x',
      autoHide: false,
      scrollbarMinSize: 25,
      scrollbarMaxSize: 85
    }
  };

  init() {
    window.addEventListener('resize', this.run.bind(this));
    document.addEventListener("DOMContentLoaded", this.run.bind(this));
  }

  run() {
    if (window.innerWidth <= this.options.breakpoint) {
      document.querySelectorAll(this.options.selector).forEach(el => {
        let scroll = new SimpleBar(el, this.options.simplebarSettings);
        this.scrolls.push(scroll);
      });
    } else if (this.scrolls.length > 0) {
      for (let i = this.scrolls.length - 1; i >= 0; i--) {
        this.scrolls[i].unMount();
        this.scrolls.splice(i, 1);
      }
    }
  }
}
